import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export type CreateMercadoPagoPreferenceInput = {
  companyId: string;
  serviceId: string;
  description: string;
  urgency: "baixa" | "normal" | "alta";
  quantity: number;
  serviceRequestId?: string;
};

export type CreateMercadoPagoPreferenceResult = {
  ok: boolean;
  serviceRequestId: string;
  preferenceId: string;
  amount: number;
  initPoint: string;
  sandboxInitPoint?: string;
};

export function getMercadoPagoPublicKey() {
  return import.meta.env.VITE_MERCADO_PAGO_PUBLIC_KEY as string | undefined;
}

export async function createMercadoPagoPreference(input: CreateMercadoPagoPreferenceInput) {
  if (!functions) {
    throw new Error("Firebase Functions nao configurado.");
  }

  const callable = httpsCallable<CreateMercadoPagoPreferenceInput & { appUrl: string }, CreateMercadoPagoPreferenceResult>(
    functions,
    "createMercadoPagoPreference"
  );

  const appUrl = import.meta.env.VITE_IMOBI_APP_URL || window.location.origin;
  const response = await callable({ ...input, appUrl });
  return response.data;
}
